var allProductsData = {},
    commonProductsData = {};

function showAppropriateStep() {
    const e = new URLSearchParams(window.location.search);
    let t = e.get("step");
    const n = document.querySelectorAll("section[data-step]");
    if (!t) {
        const o = Array.from(n).find((e => !e.classList.contains("hidden")));
        o && (t = o.dataset.step, e.set("step", t), window.history.replaceState(null, null, "?" + e.toString()))
    }
    localStorage.setItem("current-step", t), n.forEach((e => {
        if (e.dataset.step === t) {
            if (e.classList.remove("hidden"), "color-select" === t) {
                const {
                    filteredBraProducts: e,
                    filteredUnderwearProducts: t
                } = filterProducts();
                e && t && (generateSwatchesForProducts(e, ".preview-1 .preview-variant-inner", "bra-size-selected"), generateSwatchesForProducts(t, ".preview-2 .preview-variant-inner", "underwear-size-selected")), updateDesignCounts(), updateInfopreview(), setupTabButtonClickHandlers(), setupTabSwatchClickHandlers()
            }
        } else e.classList.add("hidden")
    }))
}

function generateSwatchesForProducts(e, t, n) {
    let o = "";
    const a = localStorage.getItem(n);
    e.forEach((e => {
        const t = Object.values(e.variants).find((e => e.title === a && e.inventory_quantity > 0));
        if (t) {
            const n = e.tags || [];
            let a = "";
            n.some((e => "prints" === e.toLowerCase())) && (a += "prints "), n.some((e => "solids" === e.toLowerCase())) && (a += "solids "), n.some((e => "new" === e.toLowerCase())) && (a += "new"), o += `\n                <div class="type_swatch all ${a.trim()}">\n                <button href="#" class="tab-swatch "\n                        data-name="${e.design_name}"\n                        data-type="${e.shape_style}"\n                        data-id="${e.product_id}"\n                        data-inventory="${t.inventory_quantity}"\n                        data-handle="${e.product_handle}"> \n                    <img src="${e.swatch_icon}">\n                </button>\n            </div>\n            `
        }
    }));
    const r = document.querySelector(t);
    r && (r.innerHTML = o)
}

function setupTabButtonClickHandlers() {
    document.querySelectorAll(".preview-1, .preview-2").forEach((e => {
        const t = e.querySelectorAll(".tab-button"),
            n = e.querySelectorAll(".type_swatch");
        t.forEach((e => {
            e.addEventListener("click", (function() {
                t.forEach((e => e.classList.remove("active"))), this.classList.add("active");
                const e = this.getAttribute("data-name");
                n.forEach((t => {
                    "all" === e || t.classList.contains(e) ? t.style.display = "" : t.style.display = "none"
                }))
            }))
        }))
    }))
}

function updateDesignCounts() {
    document.querySelectorAll(".preview-1, .preview-2").forEach((e => {
        const t = e.querySelectorAll(".tab-button"),
            n = e.querySelectorAll(".type_swatch");
        t.forEach((e => {
            const t = e.getAttribute("data-name");
            let o = 0;
            n.forEach((e => {
                ("all" === t || e.classList.contains(t)) && o++
            }));
            const a = e.querySelector(".design-count");
            a && (a.textContent = `(${o})`)
        }))
    }))
}

function setupTabSwatchClickHandlers() {
    const e = document.querySelector(".preview-1"),
        t = document.querySelector(".preview-2");
    setupContainerSwatches(e, "designName1"), setupContainerSwatches(t, "designName2")
}

function setupContainerSwatches(e, t) {
    if (!e) return;
    const n = e.querySelectorAll(".tab-swatch"),
        o = e.querySelector(".type-label--selected");
    n.forEach((e => {
        e.addEventListener("click", (function() {
            n.forEach((e => e.classList.remove("active"))), this.classList.add("active");
            const e = this.closest(".m-section-my");
            e && (window.matchMedia("(min-width: 768px)").matches ? e.scrollIntoView({
                behavior: "smooth",
                block: "center"
            }) : e.scrollIntoView({
                behavior: "smooth",
                block: "start"
            }));
            const a = this.getAttribute("data-name");
            localStorage.setItem(t, a), o && (o.textContent = a)
        }))
    }));
    const a = localStorage.getItem(t);
    if (a) {
        const e = Array.from(n).find((e => e.getAttribute("data-name") === a));
        e && (e.click(), updateInfopreview())
    } else n.length > 0 && (n[0].click(), updateInfopreview())
}

function findAllCommonProducts() {
    const e = [],
        t = new Set,
        n = Object.values(allProductsData).flat();
    return n.forEach((e => t.add(e.design_name))), t.forEach((t => {
        const o = n.filter((e => e.design_name === t));
        o.length > 1 && o.forEach((t => {
            e.some((e => e.product_id === t.product_id)) || e.push(t)
        }))
    })), e
}

function filterProducts() {
    localStorage.getItem("bra-product-type"), localStorage.getItem("bra-size-selected"), localStorage.getItem("underwear-product-type"), localStorage.getItem("underwear-size-selected");
    let e = [],
        t = [];
    return e = allProductsData["allProduct-bra"], t = allProductsData["allProduct-underwear"], {
        filteredBraProducts: e,
        filteredUnderwearProducts: t
    }
}

function updateStepIndicators(e, t) {
    const n = document.querySelector(`${t} .matching-undie_step_conatiner`),
        o = document.querySelector(`${t} .matching-undie_step_conatiner_mobile`);
    n && o && (updateCounter(n, e, !0), updateCounter(o, e, !1))
}

function updateCounter(e, t, n) {
    e.querySelectorAll('[class*="matching-undie_steps_"]').forEach(((e, o) => {
        const a = "matching-undie_steps_" + (o + 1);
        n ? e.classList.toggle("active", a <= t) : (e.classList.toggle("active", a === t), e.classList.toggle("hidden", a !== t))
    }))
}
showAppropriateStep(), window.onpopstate = function() {
    showAppropriateStep()
};
let price1 = 0,
    price2 = 0;

function updateInfopreview() {
    const e = document.querySelectorAll(".preview-1 .tab-swatch"),
        t = document.querySelectorAll(".preview-2 .tab-swatch");

    function n(e, t) {
        const n = e.getAttribute("data-name"),
            o = e.getAttribute("data-type"),
            a = e.querySelector("img").getAttribute("src"),
            r = localStorage.getItem(1 === t ? "bra-size-selected" : "underwear-size-selected"),
            c = localStorage.getItem(1 === t ? "bra-product-type" : "underwear-product-type");
        return updateInfo(`.page-step-${t}-wapper`, `.page-step-${t}`, a, o, r, c), parseFloat(searchAndUpdateProductDetails(`.page-step-${t}-wapper`, n, c, r, `.page-step-${t}-info`, `.page-step-${t}`, ".page-step-3 .prev_placeholder" + (1 === t ? "" : "2")))
    }
    e.forEach((e => {
        e.addEventListener("click", (function() {
            price1 = n(this, 1), c()
        }))
    })), t.forEach((e => {
        e.addEventListener("click", (function() {
            price2 = n(this, 2), c()
        }))
    }));
    let o = null,
        a = null;

    function r(e, t, n, o) {
        if (0 === e.length) return;
        let a;
        do {
            a = Math.floor(Math.random() * e.length)
        } while (a === n && e.length > 1);
        const r = e[a];
        o(a), r.click()
    }

    function c() {
        const e = price1 + price2;
        let t = new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 0
        }).format(e).replace("₹", "RS.");
        const n = document.querySelector("#next-3 .total-price-match");
        n && (n.textContent = t)
    }
    document.getElementById("surprise-me").addEventListener("click", (function() {
        try {
            r(e, 0, o, (e => o = e)), r(t, 0, a, (e => a = e)), c()
        } catch (e) {}
    })), c()
}

function updateInfo(e, t, n, o, a) {
    const r = document.querySelector(e);
    if (r) {
        const e = r.querySelector(`${t}-design`);
        e && (e.textContent = `${o}, ${a}`)
    }
}

function searchAndUpdateProductDetails(e, t, n, o, a, r, c) {
    let i = !1,
        s = 0;
    const d = document.querySelector(e);
    let l;
    if (e.includes("step-1")) l = allProductsData["allProduct-bra"];
    else {
        if (!e.includes("step-2")) return;
        l = allProductsData["allProduct-underwear"]
    }
    return l.forEach((e => {
        if (e.design_name === t) {
            i = !0;
            const t = document.querySelector(a);
            if (t) {
                t.setAttribute("data-productID", e.product_id), t.setAttribute("data-handle", e.product_handle);
                let n = d.querySelector(".preview-1 .type_icon");
                const o = document.querySelector(`${r}-price`),
                    a = document.querySelector(c);
                ".page-step-1" === r && (n = d.querySelector(".preview-1 .type_icon")), ".page-step-2" === r && (n = d.querySelector(".preview-2 .type_icon"));
                new Intl.NumberFormat("en-IN", {
                    style: "currency",
                    currency: "INR",
                    minimumFractionDigits: 0
                }).format(parseFloat(e.price.replace(/,/g, "")));
                o.textContent = e.price, a.srcset = e.custom_tool_preview_image, s = parseFloat(e.price.replace(/,/g, "")), n && (n.srcset = e.custom_tool_preview_image)
            }
        }
    })), s
}

function snfWidgetCode(params) {
  let productCode
  if(params.includes("Bra") || params.includes("Bralette")){
    if(document.querySelector('.select-page button.tab-button.active')?.dataset?.collection == 'womens-tshirt-bra') {
      productCode = "TC-Women-T-shirt Bra"
    } else {
      productCode = "TC-Women-Bralettes"
    }
  }
  if(params.includes("Bikini") || params.includes("Brief") || params.includes("Hipster") || params.includes("Boyshort")){
    document.getElementById("snfidmen").removeAttribute("fmf-widget-manager");
    productCode = "TC-Women-Underwear"
  }
  // window.alert("productCode"+productCode)
  if (productCode) {
      let productDiv = document.querySelector('[fmf-widget-manager]');
      if (productDiv) {
        productDiv.setAttribute('product-code', productCode);
      }
  }
}

function loadScript() {
	let scripts = [
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/runtime.js",
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/polyfills.js",
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/scripts.js",
		"https://d1pwxj66mjl9h0.cloudfront.net/angular/main.js"
	];

	scripts.forEach(function(src) {
		let script = document.createElement('script');
		script.src = src;
		script.async = true; // Load script asynchronously
		document.body.appendChild(script);
	});
}

function handleSectionActions(e) {
    const t = document.querySelector(e);
    let n = t.getAttribute("data-step");
    if (!t) return;
    const o = t.querySelectorAll(".m-richtext__button_outter .m-richtext__button[data-open]"),
        a = t.querySelector(".tab-component"),
        r = t.querySelector("div[data-variant-picker]"),
        c = t.querySelector(".m-sticky-addtocart"),
        i = t.querySelectorAll('.m-product-option--node input[type="radio"]'),
        s = t.querySelector("img.prev_placeholder"),
        d = document.querySelector(".page-step-1-review-title"),
        l = document.querySelector(".page-step-2-review-title");
    a.classList.remove("hidden"), o.forEach((i => {
        i.addEventListener("click", (function() {
            const s = i.getAttribute("data-open");
            o.forEach((e => e.classList.remove("active"))), i.classList.add("active"), c.classList.add("hidden"), a.classList.remove("hidden"), r.classList.add("hidden"),
                function(e) {
                    const n = t.querySelectorAll(".type_button");
                    n.forEach((t => {
                        t.classList.contains(e) ? t.classList.remove("hidden") : t.classList.add("hidden")
                    }))
                }(s), ".page-step-1" == e && (d.innerHTML = s), ".page-step-2" == e && (l.innerHTML = s), localStorage.setItem(`${n}-match-type`, s), updateStepIndicators(2)
        }))
    }));
    const u = t.querySelectorAll(".type_button button");
    u.forEach((o => {
        o.addEventListener("click", (function() {
            u.forEach((e => e.classList.remove("active"))), o.classList.add("active");
            const a = o.getAttribute("data-prev-img"),
                c = o.getAttribute("data-collection"),
                i = o.closest(".type_button").querySelector(".type_product_data"),
                d = o.getAttribute("data-name"),
                l = o.closest(".type_button");
            // window.alert("snf"+d) 
            setTimeout(function() {                 
              snfWidgetCode(d)
            }, 1000); // 5 seconds delay
            // Load the scripts after a delay
            setTimeout(loadScript, 1000); // 3 seconds delay
            let p = "";
            i && (p = localStorage.getItem(d)), a && s && (s.src = a, s.srcset = a), r.classList.remove("hidden"),
                function(e) {
                    if (!e) return;
                    const n = t.querySelector(".sizes-all");
                    if (!n) return;
                    const o = Array.from(n.querySelectorAll(".m-product-option--node")),
                        a = Array.from(e.classList);
                    o.forEach((e => {
                        const t = e.getAttribute("data-value");
                        a.includes(t.toLowerCase()) ? e.classList.remove("hidden") : e.classList.add("hidden")
                    }))
                }(l), ".page-step-1" == e && updateStepIndicators("matching-undie_steps_2", ".page-step-1"), ".page-step-2" == e && updateStepIndicators("matching-undie_steps_4", ".page-step-2"),
                function(e) {
                    try {
                        decodeURIComponent(e);
                        const t = JSON.parse(e);
                        allProductsData[`allProduct-${n}`] = t
                    } catch (e) {}
                }(p), localStorage.setItem(`${n}-product-type`, d), localStorage.setItem(`${n}-collection`, c);
            const m = o.closest(".m-section-my");
            m && (window.matchMedia("(min-width: 768px)").matches ? m.scrollIntoView({
                behavior: "smooth",
                block: "center"
            }) : m.scrollIntoView({
                behavior: "smooth",
                block: "end"
            })), updateStepIndicators(3)
        }))
    })), i.forEach((e => {
        e.addEventListener("change", (function() {
            if (this.value.includes("!")) {
              this.value = this.value.replace(/!([a-z])/i, (match, p1) => ` / ${p1.toUpperCase()}`);
            }
            this.checked && (c.classList.remove("hidden"), localStorage.setItem(`${n}-size-selected`, this.value))
            //this.checked && (c.classList.remove("hidden"), localStorage.setItem(`${n}-size-selected`, this.value), updateStepCounter())
        }))
    })), document.addEventListener("DOMContentLoaded", (function() {
        const e = new URLSearchParams(window.location.search).get("callback");
        e && window[e] && "function" == typeof window[e] && window[e]()
    }))
}

function fetchProductVariantIdByHandle(e, t) {
    return fetch("/products/" + e + ".json").then((function(t) {
        if (t.ok) return t.json();
        throw new Error("Error fetching product by handle: " + e)
    })).then((function(e) {
        var n = e.product.variants.find((function(e) {
            return e.title === t
        }));
        return n ? n.id : null
    }))
}
async function addProductsToCart(e, t, n, o) {
    try {
        var a = await fetchProductVariantIdByHandle(e, n),
            r = await fetchProductVariantIdByHandle(t, o);
        let c = [];
        a && c.push({
            id: a,
            quantity: 1,
            properties: {
                comboType: "Bra + Undie"
            }
        }), r && c.push({
            id: r,
            quantity: 1,
            properties: {
                comboType: "Bra + Undie"
            }
        });
        let i = {
            items: c
        };
        await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(i)
        }).then((e => e.json())).then((e => {
            if (window.MinimogSettings && window.MinimogSettings.use_ajax_atc) {
                updateCartUI(), window.MinimogSettings.enable_cart_drawer ? window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer) : window.MinimogTheme.Notification.show({
                    target: document.body,
                    method: "appendChild",
                    type: "success",
                    message: "Items added to cart",
                    last: 3e3,
                    sticky: !1
                });
                document.getElementById("MinimogCartDrawer").classList.add("m-cart-drawer--active"), window.MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, e)
            } else window.location = window.MinimogSettings.routes.cart
        })).catch((() => {}))
    } catch (e) {}
}
async function updateCartUI() {
    await updateCartSection("/cart?section_id=cart-template", "[data-minimog-cart-items]", "[data-cart-subtotal]", "[data-minimog-cart-discounts]", "[data-minimog-gift-wrapping]"), await updateCartSection("/cart?section_id=cart-drawer", "[data-minimog-cart-items]", "[data-cart-subtotal]", "[data-minimog-cart-discounts]", "[data-minimog-gift-wrapping]");
    const e = await fetch("/cart.js").then((e => e.json()));
    updateCartCount(e.item_count), openCartDrawer()
}
async function updateCartSection(e, t, n, o, a) {
    try {
        const r = await fetch(e),
            c = await r.text(),
            i = (new DOMParser).parseFromString(c, "text/html"),
            s = i.querySelector(t).innerHTML;
        document.querySelectorAll(t).forEach((e => e.innerHTML = s));
        const d = i.querySelector(n).innerHTML;
        document.querySelectorAll(n).forEach((e => e.innerHTML = d));
        const l = i.querySelector(o).innerHTML;
        document.querySelectorAll(o).forEach((e => e.innerHTML = l));
        const u = i.querySelector(a).innerHTML;
        document.querySelectorAll(a).forEach((e => e.innerHTML = u))
    } catch (e) {}
}

function updateCartCount(e) {
    document.querySelectorAll(".m-cart-count-bubble").forEach((t => {
        e > 0 ? (t.textContent = e, t.classList.remove("hidden")) : t.classList.add("hidden")
    }))
}

function updateGlobalCartCount(e) {
    document.querySelectorAll(".m-cart-count-bubble").forEach((t => {
        e > 0 ? (t.textContent = e, t.classList.remove("m:hidden")) : (t.textContent = "", t.classList.add("m:hidden"))
    }))
}

function openCartDrawer(e) {
    const t = document.querySelector(".m-cart-drawer"),
        n = document.querySelector(".m-cart-drawer__inner");
    t && n && (e && setActiveElement(e), t.classList.add("m-cart-drawer--active"), t.classList.remove("m-cart--empty"), requestAnimationFrame((() => {
        document.documentElement.style.setProperty("--m-bg-opacity", "0.5"), n.style.setProperty("--translate-x", "0")
    })), window.MinimogEvents && MinimogTheme && MinimogTheme.pubSubEvents && window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer))
}
async function fetchLatestCartCount() {
    return new Promise((e => {
        e(parseInt(localStorage.getItem("cartItemCount"), 10) || 0)
    }))
}

function updateCartCount(e) {
    document.querySelectorAll(".m-cart-count-bubble").forEach((t => {
        e > 0 ? (t.textContent = e, t.classList.remove("hidden")) : t.classList.add("hidden")
    }))
}
document.addEventListener("DOMContentLoaded", (() => {
    handleSectionActions(".page-step-1"), handleSectionActions(".page-step-2");
    const e = document.querySelector(".next-1"),
        t = document.querySelector(".next-2"),
        n = document.querySelector(".modify-1"),
        o = document.querySelector(".modify-2"),
        a = document.querySelector("#next-3"),
        r = document.querySelector(".page-step-1"),
        c = document.querySelector(".page-step-2"),
        i = document.querySelector(".page-step-3");

    function s(e) {
        const t = new URL(window.location.href);
        t.searchParams.set("step", e), history.pushState({}, "", t), localStorage.setItem("current-step", e), showAppropriateStep()
    }

    function d() {
        const e = new URL(window.location.href);
        e.searchParams.set("return_url", "color-select"), window.history.pushState({}, "", e)
    }
    e && r && c && e.addEventListener("click", (function() {
        const e = c.getAttribute("data-step");
        r.classList.add("hidden"), c.classList.remove("hidden"), s(e)
    })), t && c && i && t.addEventListener("click", (function() {
        const e = i.getAttribute("data-step");
        c.classList.add("hidden"), i.classList.remove("hidden"), s(e)
    })), n && r && i && n.addEventListener("click", (function() {
        const e = r.getAttribute("data-step");
        i.classList.add("hidden"), r.classList.remove("hidden"), s(e), d()
    })), o && i && c && o.addEventListener("click", (function() {
        const e = c.getAttribute("data-step");
        i.classList.add("hidden"), c.classList.remove("hidden"), s(e)
    })), a && i && a.addEventListener("click", (function() {
        const e = document.querySelector(".page-step-1-info").getAttribute("data-handle"),
            t = document.querySelector(".page-step-2-info").getAttribute("data-handle"),
            n = localStorage.getItem("bra-size-selected"),
            o = localStorage.getItem("underwear-size-selected");
        e && t && n && o && addProductsToCart(e, t, n, o).then((function() {})).catch((function() {}))
    }))
}));